<template>
  <div>
    <b-breadcrumb v-if="invoice_id == null" :items="breadcrumb"></b-breadcrumb>
    <b-card
      class="mx-2 mb-2 bg-light shadow"
      header-text-variant="light"
    >
      <b-row v-if="invoice_id == null">
        <mh-input
          @update="getInvoice"
          label="Facture #"
          mhClass="col-2"
          field="number"
          :table="invoiceNumber"
          :state="invoice !== false"
        ></mh-input>
        <b-col lg="10" v-if="invoice">
          <b-row>
            <mh-input
              mhClass="col-3"
              label="Créancier"
              field="creancierID"
              readonly
              :table="invoice"
            >
            </mh-input>
            <mh-input
              mhClass="col-2"
              label="TVAC"
              field="prixTVAC"
              readonly
              :table="invoice"
              append="€"
            >
            </mh-input>
            
            <mh-input
              mhClass="col-2"
              label="Solde"
              field="solde"
              readonly
              :table="invoice"
              append="€"
            >
            </mh-input>
            <mh-input
              mhClass="col-2"
              label="Type"
              field="type"
              readonly
              :table="invoice"
            >
            </mh-input>
            <mh-input
              mhClass="col-2"
              label="Vendeur"
              field="vendeurID"
              readonly
              :table="invoice"
            >
            </mh-input>
            <b-col lg="1" class="align-self-center" v-if="invoice.releve_compteID.value != 0">
              <b-button target="_blank"
                :href="releve_pdf" size="sm">Relevé</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row v-if="payment" class="mt-3">
        <b-col lg="12">
          <h6 v-if="!modify">Nouveau paiement</h6>
          <h6 v-else>Modifier le paiement</h6>
        </b-col>
        <mh-input
          mhClass="col-2"
          label="Date"
          field="date"
          :table="payment"
          @keyup.enter.native="focus('montant')"
        ></mh-input>
        <mh-input
          mhClass="col-2"
          label="Montant"
          field="montant"
          append="€"
          :table="payment"
          @keyup.enter.native="focus('compte_societeID')"
        ></mh-input>
        <mh-input
          mhClass="col-2"
          label="Cpt société"
          field="compte_societeID"
          :table="payment"
          @keyup.enter.native="focus('compte_src')"
        ></mh-input>
        <mh-input
          mhClass="col-2"
          label="Cpt source"
          field="compte_src"
          :table="payment"
          @keyup.enter.native="focus('note')"
        ></mh-input>
        <mh-input
          mhClass="col-2"
          label="Extrait"
          field="note"
          :table="payment"
          @keyup.enter.native="savePayment"
        ></mh-input>
        <b-col lg="2" style="align-self: start" class="mt-1">
          <b-button @click="savePayment" size="sm" variant="success"
            >Confirmer</b-button
          >
          <b-button
            v-if="modify"
            @click="cancelModify"
            size="sm"
            variant="danger"
            class="ml-2"
            >Annuler</b-button
          >
        </b-col>
      </b-row>
      <hr v-if="payment" />

      <b-row v-if="invoice" class="mt-3">
        <b-col lg="12">
          <b-table
            hover
            small
            :fields="paymentsFields"
            :items="invoice.paiements"
            v-if="invoice.paiements.length > 0"
          >
            <template v-slot:cell(date)="data">{{
              toDate(data.item.date)
            }}</template>
            <template v-slot:cell(compte)="data">{{
              data.item.compte
            }}</template>
            <template v-slot:cell(compte_src)="data">{{
              data.item.compte_src
            }}</template>
            <template v-slot:cell(note)="data">{{ data.item.note }}</template>
            <template v-slot:cell(montant)="data"
              >{{ twoDigits(data.item.montant) }} €</template
            ><template v-slot:cell(actions)="data">
              <div class="d-flex justify-content-center">
                <b-button
                  class="ml-3 btn-xs"
                  icon
                  size="sm"
                  variant="success"
                  @click="editPayment(data.item.ID)"
                  ><b-icon-pencil-fill></b-icon-pencil-fill
                ></b-button>
                <b-button
                  class="ml-3 btn-xs"
                  icon
                  size="sm"
                  variant="danger"
                  @click="deletePayment(data.item.ID)"
                  ><b-icon-x-circle></b-icon-x-circle
                ></b-button>
              </div>
            </template>
            <template v-slot:bottom-row>
              <td />
              <td />
              <td />
              <td />
              <td>
                <strong>
                  Total :
                  <span class="float-right"
                    >{{ twoDigits(paymentsTotalVTAC) }} €</span
                  >
                </strong>
              </td>
              <td />
            </template>
          </b-table>
          <div v-else>
            <i>Pas encore de paiements pour cette facture</i>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import invoices from "@/services/invoices.js";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "addInvoicesPayments",
  props: {
    invoice_id: String
  },
  components: {
    MhInput,
  },
  computed: {
    paymentsTotalVTAC() {
      return this.twoDigits(
        this.invoice.paiements.reduce((a, b) => a + Number(b.montant), 0)
      );
    },
    releve_pdf() {
      return (
        this.$store.getters.url + "/account-statement/" +
        this.invoice.releve_compteID.value +
        "/pdf?token=" +
        encodeURIComponent(localStorage.getItem("vue-token"))
      );
    },
  },
  created() {
    if(this.$props.invoice_id !== null) {
       this.invoiceNumber.number.value = this.invoice_id;
    } 
    this.getInvoice();
  },
  methods: {
    
    focus(id) {
      document.getElementById(id).focus();
      document.getElementById(id).select();
    },
    cancelModify() {
      this.modify = false;
      this.getInvoice();
      this.$emit('modified');
    },
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
    editPayment(id) {
      invoices.payment(this.invoice.ID.value, id).then((response) => {
        this.payment = response.data;
        this.payment.date.type = "varchar";
        this.payment.date.pattern = "[0-9]{4}-[0-9]{2}-[0-9]{2}";
        this.modify = true;
        this.$nextTick(() => {
          document.getElementById("montant").focus();
          document.getElementById("montant").select();
        });
      });
    },
    deletePayment(id) {
      invoices.deletePayment(this.invoice.ID.value, id).then(() => {
        this.getInvoice({ focus: true });
        this.$emit('modified');
        this.$bvToast.toast("Paiement supprimé", {
          title: `Recuperator`,
          toaster: "b-toaster-top-right",
          variant: "success",
          autoHideDelay: 2000,
          solid: false,
        });
      });
    },
    savePayment() {
      if (this.modify) {
        invoices
          .savePayment(
            this.invoice.ID.value,
            this.payment.ID.value,
            this.payment
          )
          .then((response) => {
            if (response.data.success) {
              this.$bvToast.toast("Paiement modifié", {
                title: `Recuperator`,
                toaster: "b-toaster-top-right",
                variant: "success",
                autoHideDelay: 2000,
                solid: false,
              });
              for (let el in this.invoice) {
                if (this.payment[el]) {
                  this.payment[el].error = false;
                }
              }
              this.modify = false;
              this.getInvoice({ focus: true });
              this.$emit('modified');
            } else if (response.data.fail) {
              for (let el in this.invoice) {
                if (this.payment[el]) {
                  this.payment[el].error = false;
                }
              }
              response.data.fail.forEach((element) => {
                this.payment[element.field].error = element.errors.join(" ; ");
              });
            }
          });
      } else {
        invoices
          .createPayment(this.invoice.ID.value, this.payment)
          .then((response) => {
            if (response.data.success) {
              this.$bvToast.toast("Paiement encodé", {
                title: `Recuperator`,
                toaster: "b-toaster-top-right",
                variant: "success",
                autoHideDelay: 2000,
                solid: false,
              });
              for (let el in this.invoice) {
                if (this.payment[el]) {
                  this.payment[el].error = false;
                }
              }
              this.getInvoice({ focus: true });
              this.$emit('modified');
            } else if (response.data.fail) {
              for (let el in this.invoice) {
                if (this.payment[el]) {
                  this.payment[el].error = false;
                }
              }
              response.data.fail.forEach((element) => {
                this.payment[element.field].error = element.errors.join(" ; ");
              });
            }
          });
      }
    },
    getInvoice(data = {}) {
      let id = Number(this.invoiceNumber.number.value);
      invoices.get(id).then((response) => {
        if (response.data) {
          this.invoice = response.data;
          invoices
            .payment(this.invoiceNumber.number.value, "new")
            .then((response) => {
              this.payment = response.data;
              this.payment.date.type = "varchar";
              this.payment.date.pattern = "[0-9]{4}-[0-9]{2}-[0-9]{2}";
            });
          if (data.focus) {
            document.getElementById("number").focus();
            document.getElementById("number").select();
          }
        } else {
          this.invoice = false;
          this.payment = false;
        }
      });
    },
  },
  data() {
    return {
      invoiceNumber: {
        number: {
          label: "Numéro de facture",
          type: "INT",
          value: "",
        },
      },
      modify: false,
      invoice: false,
      payment: false,
      paymentsFields: [
        {
          key: "date",
          label: "Date",
          sortable: true,
        },
        {
          key: "compte",
          label: "Compte société",
          sortable: true,
        },
        {
          key: "compte_src",
          label: "Compte source",
          sortable: true,
        },
        {
          key: "note",
          label: "Note",
          sortable: false,
        },
        {
          key: "montant",
          label: "Montant",
          sortable: true,
          class: "text-right",
        },
        {
          key: "actions",
          label: "",
          sortable: true,
          class: "text-right",
        },
      ],
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Factures",
          to: { name: "invoices" },
        },
        {
          text: "Réception de paiements",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>